const getBrowserWidth = () => {
    let w = window,
    d = document,
    documentElement = d.documentElement,
    body = d.getElementsByTagName('body')[0]

    return w.innerWidth || documentElement.clientWidth || body.clientWidth
}

export default getBrowserWidth